
import {Component, Prop} from 'nuxt-property-decorator';
import Vue from 'vue';
import LoadingContext from '~/components/util/LoadingContext.vue';


@Component({
  components: {LoadingContext},
})
export default class Form extends Vue {
  @Prop({
    type: Boolean,
    required: false,
    default: false,
  })
  loading!: boolean

  @Prop({
    type: String,
    required: false,
    default: '',
  })
  innerClass!: string

  submit(event: Event) {
    if (!this.loading) {
      this.$emit('submit', event)
    }
    event.preventDefault();
  }


}
